export default __webpack_public_path__ + "static/media/icon-settings-mobile.f44fc977.svg";